import $cuuN1$arAEmodulejs from "./ar-AE.module.js";
import $cuuN1$bgBGmodulejs from "./bg-BG.module.js";
import $cuuN1$csCZmodulejs from "./cs-CZ.module.js";
import $cuuN1$daDKmodulejs from "./da-DK.module.js";
import $cuuN1$deDEmodulejs from "./de-DE.module.js";
import $cuuN1$elGRmodulejs from "./el-GR.module.js";
import $cuuN1$enUSmodulejs from "./en-US.module.js";
import $cuuN1$esESmodulejs from "./es-ES.module.js";
import $cuuN1$etEEmodulejs from "./et-EE.module.js";
import $cuuN1$fiFImodulejs from "./fi-FI.module.js";
import $cuuN1$frFRmodulejs from "./fr-FR.module.js";
import $cuuN1$heILmodulejs from "./he-IL.module.js";
import $cuuN1$hrHRmodulejs from "./hr-HR.module.js";
import $cuuN1$huHUmodulejs from "./hu-HU.module.js";
import $cuuN1$itITmodulejs from "./it-IT.module.js";
import $cuuN1$jaJPmodulejs from "./ja-JP.module.js";
import $cuuN1$koKRmodulejs from "./ko-KR.module.js";
import $cuuN1$ltLTmodulejs from "./lt-LT.module.js";
import $cuuN1$lvLVmodulejs from "./lv-LV.module.js";
import $cuuN1$nbNOmodulejs from "./nb-NO.module.js";
import $cuuN1$nlNLmodulejs from "./nl-NL.module.js";
import $cuuN1$plPLmodulejs from "./pl-PL.module.js";
import $cuuN1$ptBRmodulejs from "./pt-BR.module.js";
import $cuuN1$ptPTmodulejs from "./pt-PT.module.js";
import $cuuN1$roROmodulejs from "./ro-RO.module.js";
import $cuuN1$ruRUmodulejs from "./ru-RU.module.js";
import $cuuN1$skSKmodulejs from "./sk-SK.module.js";
import $cuuN1$slSImodulejs from "./sl-SI.module.js";
import $cuuN1$srSPmodulejs from "./sr-SP.module.js";
import $cuuN1$svSEmodulejs from "./sv-SE.module.js";
import $cuuN1$trTRmodulejs from "./tr-TR.module.js";
import $cuuN1$ukUAmodulejs from "./uk-UA.module.js";
import $cuuN1$zhCNmodulejs from "./zh-CN.module.js";
import $cuuN1$zhTWmodulejs from "./zh-TW.module.js";

var $0815878b47e2c7ae$exports = {};


































$0815878b47e2c7ae$exports = {
    "ar-AE": $cuuN1$arAEmodulejs,
    "bg-BG": $cuuN1$bgBGmodulejs,
    "cs-CZ": $cuuN1$csCZmodulejs,
    "da-DK": $cuuN1$daDKmodulejs,
    "de-DE": $cuuN1$deDEmodulejs,
    "el-GR": $cuuN1$elGRmodulejs,
    "en-US": $cuuN1$enUSmodulejs,
    "es-ES": $cuuN1$esESmodulejs,
    "et-EE": $cuuN1$etEEmodulejs,
    "fi-FI": $cuuN1$fiFImodulejs,
    "fr-FR": $cuuN1$frFRmodulejs,
    "he-IL": $cuuN1$heILmodulejs,
    "hr-HR": $cuuN1$hrHRmodulejs,
    "hu-HU": $cuuN1$huHUmodulejs,
    "it-IT": $cuuN1$itITmodulejs,
    "ja-JP": $cuuN1$jaJPmodulejs,
    "ko-KR": $cuuN1$koKRmodulejs,
    "lt-LT": $cuuN1$ltLTmodulejs,
    "lv-LV": $cuuN1$lvLVmodulejs,
    "nb-NO": $cuuN1$nbNOmodulejs,
    "nl-NL": $cuuN1$nlNLmodulejs,
    "pl-PL": $cuuN1$plPLmodulejs,
    "pt-BR": $cuuN1$ptBRmodulejs,
    "pt-PT": $cuuN1$ptPTmodulejs,
    "ro-RO": $cuuN1$roROmodulejs,
    "ru-RU": $cuuN1$ruRUmodulejs,
    "sk-SK": $cuuN1$skSKmodulejs,
    "sl-SI": $cuuN1$slSImodulejs,
    "sr-SP": $cuuN1$srSPmodulejs,
    "sv-SE": $cuuN1$svSEmodulejs,
    "tr-TR": $cuuN1$trTRmodulejs,
    "uk-UA": $cuuN1$ukUAmodulejs,
    "zh-CN": $cuuN1$zhCNmodulejs,
    "zh-TW": $cuuN1$zhTWmodulejs
};


export {$0815878b47e2c7ae$exports as default};
//# sourceMappingURL=intlStrings.module.js.map
